import { bool, func, number, shape } from 'prop-types';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { Button } from 'reactstrap';

import api from '../../REST/api';
import withApiRequest from '../../REST/with-api-request';

class AddQuoteButton extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const { opportunityId, onRequest } = this.props;
    onRequest({ data: { opportunityId } }).catch(console.error); // eslint-disable-line no-console
  }

  render() {
    const { loading, response } = this.props;

    if (response) {
      return <Redirect push to={`/quotes/${response.id}/edit`} />;
    }

    return (
      <Button color="primary" onClick={this.handleClick} disabled={loading}>
        Create
      </Button>
    );
  }
}

AddQuoteButton.propTypes = {
  opportunityId: number.isRequired,
  loading: bool.isRequired,
  onRequest: func.isRequired,

  response: shape({ id: number }),
};

AddQuoteButton.defaultProps = {
  response: undefined,
};

export default withApiRequest({
  query: api.addQuote,
  successMessage: 'Created Quote',
  error: 'flash',
})(AddQuoteButton);
